import VConsole from 'vconsole';
export default {
  data() {
    var _localStorage;

    let theme = '';
    if (window.matchMedia('(prefers-color-scheme: dark)').matches) theme = 'dark';
    return {
      theme,
      server_: ((_localStorage = localStorage) === null || _localStorage === void 0 ? void 0 : _localStorage.getItem('server')) || 'CN',
      developerMode: false,
      vConsoleOpen_: false,
      vConsole: undefined,
      homepageActive: 'events',
      dialogSettings: {
        title: this.$t('common.info'),
        messageAlign: 'left',
        closeOnClickOverlay: true
      },
      themeVars: {
        navBarBackground: '#212121',
        navBarTitleTextColor: '#ffffff',
        navBarTextColor: '#ffffff',
        navBarIconColor: '#ffffff'
      }
    };
  },

  computed: {
    server: {
      get() {
        return this.server_;
      },

      set(v) {
        var _localStorage2;

        this.server_ = v;
        (_localStorage2 = localStorage) === null || _localStorage2 === void 0 ? void 0 : _localStorage2.setItem('server', v);
      }

    },
    vConsoleOpen: {
      get() {
        return this.vConsoleOpen_;
      },

      set(v) {
        var _this$vConsole;

        this.vConsoleOpen_ = v;
        if (v) this.vConsole = new VConsole({
          theme: this.theme
        });else (_this$vConsole = this.vConsole) === null || _this$vConsole === void 0 ? void 0 : _this$vConsole.destroy();
      }

    }
  },

  mounted() {
    window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', event => {
      if (event.matches) {
        this.theme = 'dark';
      } else {
        this.theme = '';
      }
    });
  }

};